const checkIsKeywordsActionsAllowed = (permissions, policies) => !!(permissions.manageKeywords && !policies.useKeywordsControlledVocabulary);

export default checkIsKeywordsActionsAllowed;
